class ComponentSelectorCtrl {
    constructor() {
        this.typesMap = {
            glazing: 'glazingSelector',
            handle: 'handleSelector',
            profile: 'simpleSelectBox',
            activeSash: 'simpleSelectBox',
            activeDoorSash: 'simpleSelectBox',
            security: 'simpleSelectBox',
            color: 'colorSelector',
            ornament: 'glassSelector',
            accessory: 'simpleSelectBox',
            seal: 'simpleSelectBox',
            sash: 'barsSelector',
            hingeSide: 'simpleSelectBox',
            packet: 'packetSelector',
            fixOption: 'simpleSelectBox',
            hingeType: 'simpleSelectBox',
            windowSingleTurnTiltOrTurnHingeSide: 'simpleSelectBox',
            mirrorReflection: 'toggleSimpleSelectBox',
            series: 'serieSelector',
            rollerBlindControlSides: 'simpleBlindSelector',
            rollerBlindBoxes: 'rollerBlindBoxSelector',
            rollerBlindFabrics: 'rollerBlindFabricSelector',
            internalBlindControlSides: 'simpleBlindSelector',
            internalBlindTopRails: 'internalBlindTopRailSelector',
            internalBlindLouvres: 'internalBlindLouvreSelector',
            internalBlindBottomRails: 'simpleBlindSelector',
            plisseRails: 'plisseRailSelector',
            plisseSheatings: 'plisseSheatingSelector',
            plisseMontageTypes: 'simpleBlindSelector',
            plisseDrives: 'simpleBlindSelector',
            verticalBlindControlSides: 'simpleBlindSelector',
            verticalBlindStackingTypes: 'simpleBlindSelector',
            verticalBlindTopRails: 'verticalBlindTopRailSelector',
            verticalBlindLouvres: 'verticalBlindLouvreSelector',
            verticalBlindChains: 'simpleBlindSelector',
            verticalBlindMontageTypes: 'simpleBlindSelector',
        };
    }
}

export default ComponentSelectorCtrl;
